
import { defineComponent, ref } from 'vue';
import { primitiveMessages, useNodeCanvasStore } from '../store';
import SearchableDropDown from '@/modules/globalModule/components/SearchableDropDown.vue';
import { Topic } from './storeClasses/topic';
import { Message } from './storeClasses/message';
import { toSnakeCase } from '@/modules/globalModule/components/helperMethods';
import { useGlobalStore } from '@/modules/globalModule/store';

export default defineComponent({
  name: 'EditTopicBox',
  components: {
    SearchableDropDown
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    languagePython: boolean;
    topicToEdit: undefined | Topic;
    name: string;
    allMsgs: Message[];
    isCustomMsg: boolean;
  } {
    return {
      languagePython: true,
      topicToEdit: undefined,
      name: '',
      allMsgs: [],
      isCustomMsg: false
    };
  },
  methods: {
    open() {
      const ncStore = useNodeCanvasStore();
      const globalStore = useGlobalStore();
      this.topicToEdit = globalStore.getTopic(ncStore.editingTopicId);
      if (this.topicToEdit === undefined) {
        this.exit();
        return;
      }
      this.name = this.topicToEdit.name;
      globalStore
        .getMessages()
        .forEach((msg: Message) => this.allMsgs.push(msg));
    },
    onMsgEdit() {
      if (!this.topicToEdit || !this.topicToEdit.msgType) return;
      const ncStore = useNodeCanvasStore();
      const globalStore = useGlobalStore();
      const msgToEdit = globalStore.getMessage(this.topicToEdit.msgType);
      if (!msgToEdit) return;
      ncStore.editingMsg = msgToEdit;
    },
    onMsgTrash() {
      if (!this.topicToEdit || !this.topicToEdit.msgType) return;
      const ncStore = useNodeCanvasStore();
      const globalStore = useGlobalStore();
      const msgToEdit = globalStore.getMessage(this.topicToEdit.msgType);
      if (!msgToEdit) return;
      this.allMsgs = this.allMsgs.filter((msg) => msg.id !== msgToEdit.id);
      globalStore.deleteElemById(msgToEdit.id);
      this.selectMsgOnDropDown(primitiveMessages[0]);
      globalStore.saveData();
    },
    exit() {
      const ncStore = useNodeCanvasStore();
      const globalStore = useGlobalStore();
      ncStore.editingTopicId = 'undefined';
      globalStore.saveData();
    },
    saveAndExit() {
      this.save();
      this.exit();
    },
    save() {
      this.topicToEdit!.name = this.name;
    },
    /**
     * called after a message is selected via drop down menu
     * @param msgType
     */
    chooseTopicMsgType(msgType: Message) {
      if (!msgType || !this.topicToEdit) return;
      const globalStore = useGlobalStore();
      this.topicToEdit.msgType = msgType.id;
      this.isCustomMsg = globalStore.isCustomMessage(msgType.id);
    },
    addNewCustomMsg() {
      const ncStore = useNodeCanvasStore();
      if (!this.topicToEdit || !ncStore.packageId) return;
      const globalStore = useGlobalStore();
      const newMsg = globalStore.createMessageInPkg(ncStore.packageId, {
        name: toSnakeCase(`${this.topicToEdit.name}_msg`)
      });
      ncStore.editingMsg = newMsg;

      // ensuring no duplicate names
      let msgName = newMsg.name;
      let counter = 0;
      while (this.allMsgs.find((msg) => msg.name === msgName)) {
        counter++;
        msgName = `${newMsg.name}${counter}`;
      }
      newMsg.name = msgName;

      if (!this.allMsgs.find((msg) => msg.id === newMsg.id)) {
        this.allMsgs.push(newMsg);
      }
      this.selectMsgOnDropDown(newMsg);
      globalStore.saveData();
    },
    selectMsgOnDropDown(msg: Message) {
      // selecting message visually
      // should use typeof SearchableDropDown here but causes compilation errors
      (this.$refs.topic_msg_dropdown as any).selectOption(msg);
    },
    openCode() {
      this.save();
      if (this.isCustomMsg && this.topicToEdit) {
        this.$router.push(
          `/codeView/${this.$route.params.workspaceID}?elemId=${this.topicToEdit.msgType}`
        );
      } else {
        this.$router.push(`/codeView/${this.$route.params.workspaceID}`);
      }
    }
  },
  watch: {
    active() {
      if (this.active) this.open();
    }
  }
});
